import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';

const ErrorPage = () => {
  const [searchParams] = useSearchParams();
  const errorMessage = searchParams.get('message') || 'Si è verificato un errore';

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-primary">
      <div className="w-full max-w-md p-8 glass-card rounded-card text-center">
        <h1 className="text-2xl font-bold text-red-400 mb-4">Errore di Autenticazione</h1>
        <p className="text-gray-300 mb-6">{errorMessage}</p>
        <Link to="/login" className="inline-block px-6 py-3 bg-primary text-white rounded-button hover:bg-primary-600 transition-colors">
          Torna al Login
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;